<template>
    <div class="flex-shrink px-1 py-0 border rounded bg-gray-100 border-gray-200 m-0.5 truncate hover:border-blue-500"
         :class="highlighted?'border-blue-500':'border-gray-300'"
         @mouseover="$emit('mouseover')"
         @mouseleave="$emit('mouseleave')"
    >
        <span v-if="!readonly"><i class="fas fa-times text-red-400 text-xs mr-1 hover:text-red-800"
                                  @click="$emit('remove',file.id)"></i></span>
        <span
            :class="(file.status!=='uploaded'?'text-gray-300':'hover:text-blue-500 '+(highlighted?' text-blue-500':' text-gray-600'))"
            v-text="file.name"
            class="cursor-pointer"
            @click="$emit('click')"></span>
    </div>

</template>

<script>
export default {
    props: {
        file: {},
        readonly: {
            type: Boolean, default: false
        },
        highlighted: {
            type: Boolean, default: false
        }
    },
    data() {
        return {
            renderCount: 0,
        }
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>
